import MobileDeliveryCalendarCard from "./_components/mobile-delivery-calendar-card";
import { User } from "../../../context/user-context";
import { DeliveryWithExtras } from "@/app/types/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DeliveryCalendarCardProps {
  deliveries: Record<string, DeliveryWithExtras[]>;
  userPermissions: string[];
  user: User;
}

export default function Deliveries({
  deliveries,
  userPermissions,
  user,
}: DeliveryCalendarCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold">
          Upcoming Deliveries
        </CardTitle>
      </CardHeader>
      <CardContent>
        <MobileDeliveryCalendarCard
          deliveries={deliveries}
          userPermissions={userPermissions}
          user={user}
        />
      </CardContent>
    </Card>
  );
}
